import { supportedLocales } from '$lib/i18n/index.js'

export const prerender = true

export const entries = () => {
    // map a route for each locale
    return supportedLocales.map(locale => ({
        locale
    }))
}
